import type { MyIpItem } from './types';

/** source_session_id 为原始房间字符串（最多 64 字符），不以 IP ID 推导或转换。 */
export function validateMyIpRoomId(roomId: unknown): string {
  if (typeof roomId !== 'string' || !roomId.trim() || roomId.length > 64) {
    throw new Error('Missing or invalid IP source session');
  }
  return roomId;
}

/** 只从服务端 IP 详情恢复 Agent 会话；历史缺失绑定不能回退到 ipId。 */
export function getMyIpAgentRoomId(item: Pick<MyIpItem, 'sourceSessionId'>): string {
  return validateMyIpRoomId(item.sourceSessionId);
}
